import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutItemViewModelType from '@/ViewModels/Controls/ColumnLayoutItemViewModel';

export default class ColumnLayoutItem extends Control {

    private jQueryControl: JQuery;

    public constructor(private viewModel: ColumnLayoutItemViewModelType, private element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyBindings(this.jQueryControl, {
            controlName: 'columnlayoutitem',

            controlIdent: this.identifier,

            loader: this.viewModel.isBusy,

            visible: this.viewModel.isVisible,

            columnLayoutItem: {
                tuple: this.viewModel.tuple
            },

            labelColumnWidth: this.viewModel.labelColumnWidth
        });
        
        this.widget(null);

        return this.jQueryControl;
    }
}

ComponentManager.setControl('ColumnLayoutItem', ColumnLayoutItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');